import cx from 'classnames';
import {createPortal} from 'react-dom';
import {Button} from '../atoms/Button';
import {Typography} from '../atoms/Typography';
import {emerald, silver} from '../sass/base/_exports.sass';
import {CloseLineIcon} from '../svg/CloseLineIcon';

export const ProgressAlert = ({progress, className = null, label, closeText, onClose, width}) => {
  const progressDeg = progress * 3.6;

  const style = {
    background: `conic-gradient(${emerald} ${progressDeg}deg, ${silver} 0deg)`,
  };

  return createPortal(
    <div className={cx('progress-alert', className)} style={{width: `${width}rem`}}>
      <div className="progress-alert__indicator-wrapper" style={style}>
        <div className="progress-alert__indicator" />
      </div>
      <Typography className="progress-alert__label" variant="paragraph1">
        {label}
      </Typography>
      <Button
        variant="link"
        data-qa-id="close-progress-alert"
        onClick={onClose}
        ariaLabel="dismiss progress"
      >
        {closeText || <CloseLineIcon ratio={0.75} />}
      </Button>
    </div>,
    document.body
  );
};
